import camelizeObject from '@afosto/utils/object/camelizeObject';

export default async (dataSource, request, options = {}) => {
  const { onError, transformData } = options;

  try {
    const hasPaginationModule = !!dataSource.pagination;
    const { pagination = {} } = dataSource ?? {};
    const { activePage, getPageCursor, itemsPerPage, setItemCount, setNextPageCursor } = pagination;
    const requestOptions = {};

    if (hasPaginationModule) {
      requestOptions.headers = {
        'x-page-size': itemsPerPage,
      };

      if (activePage) {
        const pageCursor = getPageCursor(activePage);

        if (pageCursor) {
          requestOptions.headers = {
            ...requestOptions.headers,
            'x-page': pageCursor,
          };
        } else {
          requestOptions.headers = {
            ...requestOptions.headers,
            'x-page': activePage + 1,
          };
        }
      }
    }

    const response = await request(dataSource, requestOptions);
    const { data } = response;
    let formattedData;

    if (transformData && typeof transformData === 'function') {
      formattedData = await transformData(data, dataSource, requestOptions);
    } else {
      formattedData = camelizeObject(data);
    }

    if (hasPaginationModule) {
      const itemCount = response?.headers?.['x-count'];
      const pageCursor = response?.headers?.['x-page'];

      if (pageCursor) {
        setNextPageCursor(pageCursor);
      }

      if (itemCount) {
        setItemCount(parseInt(itemCount, 10));
      }
    }

    return formattedData;
  } catch (err) {
    if (onError && typeof onError === 'function') {
      onError(err);
    }

    return [];
  }
};
